function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { click } from 'ol/events/condition';
import Select from 'ol/interaction/Select';
import { useCallback, useEffect } from 'react';
import { useOpenLayers } from '../react-ol';

var getSelectStyleWithTextStyles = feature => {
  return _ref => {
    var {
      selectStyles
    } = _ref;

    if (typeof selectStyles === 'function') {
      return selectStyles(feature);
    }

    var featureName = feature.get('name');

    if (featureName && selectStyles !== null && selectStyles !== void 0 && selectStyles.length) {
      var cloneStyle = selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles[0].clone();
      cloneStyle === null || cloneStyle === void 0 ? void 0 : cloneStyle.getText().setText(featureName);
      return [...(selectStyles !== null && selectStyles !== void 0 ? selectStyles : []), cloneStyle];
    }

    return selectStyles;
  };
};

/**
 * Adds `single` or `multi` select feature for any Geometry shapes
 *
 * Sets styles for Geometry shapes
 */
var useGeometrySelect = _ref2 => {
  var {
    onSelect,
    multiSelect = false,
    canSelect = false,
    selectStyles,
    interactionId,
    mapFeaturesFunc,
    layerId
  } = _ref2;
  var {
    map
  } = useOpenLayers();
  var mapFeatures = useCallback(features => {
    if (mapFeaturesFunc) {
      return mapFeaturesFunc(features);
    }

    return features;
  }, [mapFeaturesFunc]);
  /**
   * Returns selected feature ids
   */

  var handleFeatureIds = useCallback(features => {
    return features.map(feature => feature.getId()).filter(id => id);
  }, []);
  useEffect(() => {
    var vectorLayer = map === null || map === void 0 ? void 0 : map.getLayers().getArray().find(layer => layer.get('id') === layerId);
    if (!map || !canSelect || !vectorLayer) return;
    var selectedFeatures = [];
    /**
     * Handles geometry select & deselect
     */

    var handleFeatureSelect = _ref3 => {
      var {
        canMultiSelect,
        deselected,
        selected
      } = _ref3;

      // add newly selected features
      if (selected.length) {
        if (canMultiSelect) {
          selectedFeatures.push(...selected);
        } else {
          selectedFeatures = selected;
        }
      } // filter deselected features


      if (deselected.length) {
        selectedFeatures = selectedFeatures.filter(feature => !deselected.includes(feature));
      }
    };

    var featureSelect = new Select(_objectSpread({
      condition: click,
      multi: true,
      style: feature => getSelectStyleWithTextStyles(feature)({
        selectStyles
      }),
      layers: [vectorLayer]
    }, multiSelect && {
      toggleCondition: event => event.type === 'click'
    })); // set unique to id to select interaction

    featureSelect.set('interactionId', interactionId);
    featureSelect.on('select', e => {
      var {
        selected,
        deselected
      } = e;
      handleFeatureSelect({
        selected,
        deselected,
        canMultiSelect: multiSelect
      });
      var featureCollection = mapFeatures(selectedFeatures);
      var featureIds = handleFeatureIds(featureCollection);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(featureIds);
    }); // reset selectedFeatures when interaction emits change event

    featureSelect.addEventListener('change', () => {
      selectedFeatures = [];
    });
    /**
     * Reset selectedFeatures when
     * New features are added
     * Features are cleared
     */

    vectorLayer.addEventListener('propertychange', e => {
      if ((e.key === 'clearFeatures' || e.key === 'addFeatures') && selectedFeatures.length === 0) {
        selectedFeatures = [];
        vectorLayer.unset(e.key);
      }
    });
    map.addInteraction(featureSelect);
    vectorLayer.changed();
    return () => {
      map.removeInteraction(featureSelect);
    };
  }, [map, canSelect, multiSelect, selectStyles, onSelect, handleFeatureIds, mapFeatures, interactionId, layerId]);
};

export default useGeometrySelect;